import classNames from 'classnames/bind';
import styles from './Event.module.css';
import useModal from '../../../hooks/useModal';
import { setCookie } from '../../../utils/cookie';

export default function Event() {
  const cx = classNames.bind(styles);
  const { toggleModal } = useModal();

  const hideModal = () => {
    toggleModal({ type: 'component', id: 'event', isOpen: false });
    setCookie('hideEventModal', 'true', 1);
  };

  return (
    <>
      <h3 className={cx('title')}>셀펍 기능 만족도 조사</h3>
      <div className={cx('inner')}>
        <div className={cx('title')}>선생님의 의견을 들려주세요!</div>
        <div className={cx('duration')}>
          <span>참여 기간 : 2024.07.29 ~ 2024.08.12 (2주간)</span>
        </div>
        <div className={cx('content')}>
          <p>
            더 나은 셀펍이 되도록 서비스 기능 만족도 조사를 <br />
            실시합니다. 본 설문의 소요 시간은 5분 이내입니다.
            <br />
            선생님들의 소중한 의견을 기다립니다.
          </p>

          <svg
            width="186"
            height="186"
            viewBox="0 0 186 186"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="40" y="82" width="106" height="68" fill="#FFB400" />
            <path
              d="M40 82H146L98.0403 43.0893C95.1027 40.706 90.8973 40.706 87.9597 43.0893L40 82Z"
              fill="#FFB400"
            />
            <path
              d="M34.1161 47.0852C34.4469 46.3048 35.5531 46.3048 35.8839 47.0852L36.6346 48.8562C36.7318 49.0856 36.9144 49.2682 37.1438 49.3654L38.9148 50.1161C39.6952 50.4469 39.6952 51.5531 38.9148 51.8839L37.1438 52.6346C36.9144 52.7318 36.7318 52.9144 36.6346 53.1438L35.8839 54.9148C35.5531 55.6952 34.4469 55.6952 34.1161 54.9148L33.3654 53.1438C33.2682 52.9144 33.0856 52.7318 32.8562 52.6346L31.0852 51.8839C30.3048 51.5531 30.3048 50.4469 31.0852 50.1161L32.8562 49.3654C33.0856 49.2682 33.2682 49.0856 33.3654 48.8562L34.1161 47.0852Z"
              fill="#76A1F8"
            />
            <path
              d="M144.116 50.0852C144.447 49.3048 145.553 49.3048 145.884 50.0852L146.635 51.8562C146.732 52.0856 146.914 52.2682 147.144 52.3654L148.915 53.1161C149.695 53.4469 149.695 54.5531 148.915 54.8839L147.144 55.6346C146.914 55.7318 146.732 55.9144 146.635 56.1438L145.884 57.9148C145.553 58.6952 144.447 58.6952 144.116 57.9148L143.365 56.1438C143.268 55.9144 143.086 55.7318 142.856 55.6346L141.085 54.8839C140.305 54.5531 140.305 53.4469 141.085 53.1161L142.856 52.3654C143.086 52.2682 143.268 52.0856 143.365 51.8562L144.116 50.0852Z"
              fill="#77DCB3"
            />
            <path
              d="M15.4476 88.3033C15.6543 87.8155 16.3457 87.8155 16.5524 88.3033L17.3937 90.288C17.4545 90.4314 17.5686 90.5455 17.712 90.6063L19.6967 91.4476C20.1845 91.6543 20.1845 92.3457 19.6967 92.5524L17.712 93.3937C17.5686 93.4545 17.4545 93.5686 17.3937 93.712L16.5524 95.6967C16.3457 96.1845 15.6543 96.1845 15.4476 95.6967L14.6063 93.712C14.5455 93.5686 14.4314 93.4545 14.288 93.3937L12.3033 92.5524C11.8155 92.3457 11.8155 91.6543 12.3033 91.4476L14.288 90.6063C14.4314 90.5455 14.5455 90.4314 14.6063 90.288L15.4476 88.3033Z"
              fill="#FFB400"
            />
            <path
              d="M166.337 61.5639C166.585 60.9786 167.415 60.9786 167.663 61.5639L168.672 63.9456C168.745 64.1177 168.882 64.2546 169.054 64.3275L171.436 65.3371C172.021 65.5852 172.021 66.4148 171.436 66.6629L169.054 67.6725C168.882 67.7454 168.745 67.8823 168.672 68.0544L167.663 70.4361C167.415 71.0214 166.585 71.0214 166.337 70.4361L165.328 68.0544C165.255 67.8823 165.118 67.7454 164.946 67.6725L162.564 66.6629C161.979 66.4148 161.979 65.5852 162.564 65.3371L164.946 64.3275C165.118 64.2546 165.255 64.1177 165.328 63.9456L166.337 61.5639Z"
              fill="#76A1F8"
            />
            <rect
              x="57"
              y="55"
              width="73"
              height="80"
              rx="5"
              fill="white"
              stroke="#333333"
              strokeWidth="2"
            />
            <rect x="71" y="70" width="44" height="2" rx="1" fill="#333333" />
            <rect x="71" y="78" width="44" height="2" rx="1" fill="#333333" />
            <rect x="78" y="86" width="30" height="2" rx="1" fill="#333333" />
            <path d="M40 82V150L93 116L40 82Z" fill="#FFB400" />
            <path
              d="M43 84L93 116L43 148"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path d="M146 82V150L93 116L146 82Z" fill="#FFB400" />
            <path
              d="M143 84L93 116L143 148"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M40 150H146L98.0403 111.089C95.1027 108.706 90.8973 108.706 87.9597 111.089L40 150Z"
              fill="#FFB400"
            />
            <path
              d="M144 148L98.0125 111.03C95.0851 108.676 90.9149 108.676 87.9875 111.03L42 148"
              stroke="#333333"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className={cx('btn_wrap')}>
          <button
            type="button"
            className={cx('btn', 'b_t', 's44')}
            onClick={() => {
              window.open(
                'https://docs.google.com/forms/d/e/1FAIpQLSeFEEBdoreGPMU4x-8-_GiqGQSRl36fRcs7A4VJWSJP8aAglA/viewform',
                '_blank'
              );
            }}
          >
            <span>기능 만족도 조사 참여하기</span>
          </button>
          <button className={cx('')} onClick={hideModal}>
            <span className={cx('underline')}>오늘 하루 다시 보지 않기</span>
          </button>
        </div>
      </div>
    </>
  );
}
